
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"3_PC_Comp","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"DNP_01_お友達紹介","transform":"translate(-371 -529)"}},[_c('g',{attrs:{"id":"Group-6","transform":"translate(371 505)"}},[_c('g',{attrs:{"id":"Twitter_Logo_WhiteOnBlue","transform":"translate(0 24)"}},[_c('g',{attrs:{"id":"Dark_Blue","fill":"#1DA1F2","fill-rule":"nonzero"}},[_c('rect',{attrs:{"id":"Rectangle","x":"0","y":"0","width":"48","height":"48","rx":"4"}})]),_c('g',{attrs:{"id":"Logo_FIXED"}},[_c('path',{attrs:{"d":"M18.434 36.19c11.321 0 17.513-9.378 17.513-17.512 0-.266 0-.532-.018-.796A12.523 12.523 0 0039 14.696a12.286 12.286 0 01-3.535.969 6.176 6.176 0 002.706-3.405 12.335 12.335 0 01-3.909 1.494 6.16 6.16 0 00-10.489 5.614 17.474 17.474 0 01-12.685-6.43 6.16 6.16 0 001.906 8.216 6.11 6.11 0 01-2.794-.77v.077a6.157 6.157 0 004.938 6.034 6.145 6.145 0 01-2.78.105 6.162 6.162 0 005.751 4.275A12.35 12.35 0 019 33.426a17.425 17.425 0 009.434 2.76","id":"Path","fill":"#FFF","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M0 0h42a6 6 0 016 6v36a6 6 0 01-6 6H6a6 6 0 01-6-6V0z","id":"Rectangle"}})])])])])])])
          )
        }
      }
    